var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetpaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3969 14.6299C36.365 9.49116 43.635 9.49116 45.6031 14.6299L45.695 14.8698C46.9256 18.0829 50.6006 19.6052 53.7427 18.2033L53.9774 18.0986C59.0027 15.8566 64.1434 20.9973 61.9014 26.0226L61.7967 26.2573C60.3948 29.3994 61.9171 33.0744 65.1302 34.305L65.3701 34.3969C70.5088 36.365 70.5088 43.635 65.3701 45.6031L65.1302 45.695C61.9171 46.9256 60.3948 50.6006 61.7967 53.7427L61.9014 53.9774C64.1434 59.0027 59.0027 64.1434 53.9774 61.9014L53.7427 61.7967C50.6006 60.3948 46.9256 61.9171 45.695 65.1302L45.6031 65.3701C43.635 70.5088 36.365 70.5088 34.3969 65.3701L34.305 65.1302C33.0744 61.9171 29.3994 60.3948 26.2573 61.7967L26.0226 61.9014C20.9973 64.1434 15.8566 59.0027 18.0986 53.9774L18.2033 53.7427C19.6052 50.6006 18.0829 46.9256 14.8698 45.695L14.6299 45.6031C9.49116 43.635 9.49116 36.365 14.6299 34.3969L14.8698 34.305C18.0829 33.0744 19.6052 29.3994 18.2033 26.2573L18.0986 26.0226C15.8566 20.9973 20.9973 15.8566 26.0226 18.0986L26.2573 18.2033C29.3994 19.6052 33.0744 18.0829 34.305 14.8698L34.3969 14.6299Z",
    fill: "#00BAC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41.75C37.5 42.72 38.25 43.5 39.17 43.5H41.05C41.85 43.5 42.5 42.82 42.5 41.97C42.5 41.06 42.1 40.73 41.51 40.52L38.5 39.47C37.91 39.26 37.51 38.94 37.51 38.02C37.51 37.18 38.16 36.49 38.96 36.49H40.84C41.76 36.49 42.51 37.27 42.51 38.24",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 35.5V44.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 40C50 45.52 45.52 50 40 50C34.48 50 30 45.52 30 40C30 34.48 34.48 30 40 30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31V35H49",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30L45 35",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetpaid);
export default __webpack_public_path__ + "static/media/getpaid.4d8aa631587a942a41f6a2c0b632bc94.svg";
export { ForwardRef as ReactComponent };